<template>
  <div class="relative pt-5">
    <img
      class="w-64 h-64 shadow-2xl"
      style="--aspect-ratio: 1/1"
      :src="require(`../assets/mood-gifs/${mood.image}`)"
    />
    <div class="absolute top-absolute text-white curated opacity-transition rounded-l-sm text-sm">
      <p>
        curated by:
        <span class="font-bold">{{mood.curator}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mood",
  props: ["mood"]
};
</script>

<style scoped>
.top-absolute {
  right: 3px;
  bottom: 3px;
}

.curated {
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 3px 6px;
  text-align: right;
}

img {
  border: 3px solid transparent;
  -webkit-transition: border 500ms ease-out;
  -moz-transition: border 500ms ease-out;
  -o-transition: border 500ms ease-out;
  transition: border 500ms ease-out;
}

img:hover {
  border-color: rgba(255, 255, 255, 1);
}

img:hover + .curated {
  opacity: 1;
}

.opacity-transition {
  -webkit-transition: opacity 350ms ease-in-out;
  -moz-transition: opacity 350ms ease-in-out;
  -ms-transition: opacity 350ms ease-in-out;
  -o-transition: opacity 350ms ease-in-out;
  transition: opacity 350ms ease-in-out;
}

@media only screen and (max-width: 600px) {
  .curated {
    opacity: 1;
  }
}
</style>